import PropTypes from "prop-types"
import { Flex } from "antd"
import { Text } from "ui/Typography"
import { spacings } from "themes/variables"
import styles from "./CommonEmptyStateUI.module.css"
import { BookingNotFound } from "ui/Icon/DSIcon/BookingNotFound"
import { useTranslation } from "react-i18next"

const CommonEmptyStateUI = ({ titleKey, descKey }) => {
  const { t } = useTranslation()
  return (
    <Flex vertical align="center" className={styles.emptyState} justify="center" gap={spacings.XL}>
      <BookingNotFound />
      <Flex vertical align="center" gap={spacings.XS}>
        <Text size="lg" fw={500}>
          {t(titleKey)}
        </Text>
        <Text>{t(descKey)}</Text>
      </Flex>
    </Flex>
  )
}

export default CommonEmptyStateUI

CommonEmptyStateUI.propTypes = {
  titleKey: PropTypes.string.isRequired,
  descKey: PropTypes.string.isRequired,
}
